import { get, isEmpty } from 'lodash';
import { retrieveListOrObject } from 'utils';
import {
  onboardingService,
  MS_PHASE_3_ENDPOINTS,
} from 'utils/msEndpointConstants';

const { FORM } = MS_PHASE_3_ENDPOINTS;

export const getFormByRegistrationId = registrationId => {
  if (!registrationId) {
    return Promise.resolve({
      data: [],
      totalCount: 0,
    });
  }

  return onboardingService()
    .get(FORM.getFormByRegistrationId(registrationId))
    .then(r => ({
      data: get(r, 'data.data', []),
      totalCount: get(r, 'data.totalCount', 0),
    }))
    .catch(() => ({ data: [], totalCount: 0 }));
};

export const getFormParticipantsByFormIds = formIDs => {
  if (!formIDs?.length) {
    return Promise.resolve({});
  }

  return onboardingService()
    .get(...FORM.getParticipantsByFormIds({ formIDs }))
    .then(r => retrieveListOrObject(r, false))
    .catch(() => ({}));
};

export const getFormsByFilter = (filters = {}) => {
  if (isEmpty(filters)) {
    return {};
  }

  return onboardingService()
    .post(FORM.getFormsByFilter, filters)
    .then(retrieveListOrObject)
    .catch(() => []);
};
